module.exports = __webpack_public_path__ + "static/banner-7b400a780fc94e753fda12a6ea8a9577.png";